module.exports = __webpack_public_path__ + "img/blog-12.ad03d0ca.jpg";